<template>
  <div
    class="room-main"
    style="background-color: #f4fbff"
    :class="[this.isIos === true ? 'room-main-ios' : '']"
  >
    <div
      class="room-video"
      :class="[this.isIos === true ? 'room-video-ios' : '']"
    >
      <p
        class="mobitorBitrate"
        style="position: fixed; margin-top: 125px"
        id="monitorVideoBitrate"
      ></p>
      <div class="monitorVideo">
        <video ref="video" id="remoteMonitorVideo" src="" autoplay playsinline
          style="height: 100%;width: 100%;object-fit: contain"></video>
        <audio
          id="remoteMonitorAudio"
          class="hide"
          src=""
          autoplay
          playsinline
        ></audio>
      </div>
    </div>
    <div
      v-show="user_type === '5'"
      style="margin-top: 350px; display: flex; flex-direction: column"
    >
      <span style="align-self: center; font-size: 20px">見守りカメラ</span>
    </div>
    <div class="room-tool">
      <div class="quitMonitor">
        <van-button round block type="danger" @click="quitRoom">
          見守りモードを終了
        </van-button>
      </div>
    </div>
    <canvas
      ref="canvas"
      style="display: none"
      width="500"
      height="400"
    ></canvas>
  </div>
</template>

<script>
import { useCaptureVideo } from "@/hooks";
import { onMounted, ref, onBeforeUnmount } from "vue";
import { useRoute } from "vue-router";
import { lockPatientMonitor, releasePatientMonitor } from "@/services";
export default {
  name: "monitorRoom",
  data() {
    return {
      isIos: true,
      user_type: "",
    };
  },
  components: {},
  created() {
    this.iosOrAndroid();
  },
  beforeUnmount() {},
  mounted() {
    if (this.$route.query.type) {
      let type = this.$route.query.type;
      if (type == "startMonitor") {
        this.user_type = "5";
        // 患者主动进入监护模式
        this.$emit("monitor", { toPage: "monitor", method: "startMonitor" });
      } else if (type == "joinMonitor") {
        this.user_type = "4";
        // 医生进入监护模式详情页面
        this.$emit("monitor", {
          toPage: "monitor",
          method: "joinMonitor",
          id: this.$route.query.id,
          patient_id: this.$route.query.patient_id,
          ai_mode : this.$route.query.ai_mode,
        });
      }
    }
  },
  methods: {
    quitRoom() {
      this.$emit("monitor", {
        toPage: "monitor",
        method: "quitMonitor",
        fromPage: "monitorRoom",
      });
    },
    iosOrAndroid() {
      let url = window.location.href;
      if (url.indexOf("ios") !== -1) {
        console.log("URL contains 'ios'");
        this.isIos = true;
      } else {
        console.log("URL does not contain 'ios'");
        this.isIos = false;
      }
    },

    onCaptureVideo() {},
  },
  watch: {
    screenWidth: function (n, o) {},
  },
};
</script>

<style scoped>
body {
  font-size: 16px;
  background-color: #f4fbff;
  -webkit-font-smoothing: antialiased;
}
.room-main {
  width: 100%;
  height: 100%;
  background-color: rgba(159, 161, 160, 0.726);
}
.room-main-ios {
  position: relative;
}
.myVideo {
  width: 100%;
  height: 100px;
  margin: 0 auto;
}
.monitorVideo {
  width:100%;
  height:100%;
  margin-top: constant(safe-area-inset-top);
  margin-top: env(safe-area-inset-top);
  margin: 0 2px 2px 2px;
}
.room-monitor {
  margin-top: 10px;
  height: 100%;
  background-color: rgb(231, 229, 233);
  object-fit: cover;
  width: 100%;
}
.room-video {
  width: 90%;
  height: 90%;
  margin: auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  align-content: flex-start;
}
.room-video-ios {
  padding-top: constant(safe-area-inset-top);
  padding-top: env(safe-area-inset-top);
}
.video-all {
  width: 100%;
  height: 100%;
  position: relative;
}
.muted {
}
.quitMonitor {
  text-align: center;
  width: 200px;
  margin: 15px auto;
}

.mobitorBitrate {
  position: absolute;
  bottom: 0;
  right: 20px;
  z-index: 1;
}
</style>
